/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mantine/core';
import { AlertCircle } from 'tabler-icons-react';
import AppFlexbox from '../../../../common/AppFlexbox';
import AppStack from '../../../../common/AppStack';
import AppText from '../../../../common/AppText';
import AppImage from '../../../../common/AppImage';
import ProductLineItemAddonsDisplay from '../../../products/ProductLineItemAddonsDisplay';

const WsCheckoutCartProductCardBundleItems = ({
  packageItemsWithReferences,
  imageSize
}) =>
  packageItemsWithReferences.map(
    (
      {
        items,
        itemPerBundleCount,
        ecomStoreCartProduct: cartProduct,
        ecomVendorBundleProduct
      },
      index
    ) => {
      const bundleItemImage = items
        .map((i) => i.previewImage)
        .filter(Boolean)[0];

      return (
        <React.Fragment key={cartProduct.pkEcomStoreCartProduct}>
          {index > 0 && <Divider />}
          <AppStack style={{ gap: 5 }}>
            <AppFlexbox style={{ alignSelf: 'start', flex: 1 }}>
              <AppFlexbox
                style={{
                  width: imageSize,
                  height: imageSize
                }}
              >
                <AppImage
                  fit="contain"
                  height={imageSize}
                  src={bundleItemImage}
                  width={imageSize}
                />
              </AppFlexbox>

              <AppStack
                style={{
                  gap: 0,
                  textDecoration: 'none',
                  color: '#000'
                }}
              >
                <AppText style={{ fontSize: 14, fontWeight: 500 }}>
                  {items[0].lineItem.productName}
                </AppText>
                <AppFlexbox style={{ alignItems: 'center', gap: 8 }}>
                  <AppText style={{ fontSize: 12, color: '#666' }}>
                    Qty: {itemPerBundleCount}
                  </AppText>

                  {!ecomVendorBundleProduct ? (
                    <AppFlexbox
                      style={{
                        alignItems: 'center',
                        gap: 5
                      }}
                    >
                      <AlertCircle color="#C40000" size={15} />
                      <AppText
                        style={{
                          fontSize: 12,
                          color: '#C40000'
                        }}
                      >
                        Unavailable
                      </AppText>
                    </AppFlexbox>
                  ) : (
                    ecomVendorBundleProduct.count !== itemPerBundleCount && (
                      <AppFlexbox
                        style={{
                          alignItems: 'center',
                          gap: 5
                        }}
                      >
                        <AlertCircle color="#C40000" size={15} />
                        <AppText
                          style={{
                            fontSize: 12,
                            color: '#C40000'
                          }}
                        >
                          {itemPerBundleCount > ecomVendorBundleProduct.count
                            ? 'Too many selected'
                            : 'Not enough selected'}{' '}
                          ({itemPerBundleCount}/{ecomVendorBundleProduct.count})
                        </AppText>
                      </AppFlexbox>
                    )
                  )}
                </AppFlexbox>

                {items.map((item) => (
                  <ProductLineItemAddonsDisplay
                    key={item.lineItem.entityId}
                    addOns={item.lineItem.addOns}
                    count={
                      items.length > 1 ? item.lineItem.quantity : undefined
                    }
                    showVariantOptionsOnSingleLine
                    singleLineError={
                      item.outOfStock
                        ? 'Out of stock'
                        : item.tooManyInCart
                        ? 'Quantity not available'
                        : null
                    }
                  />
                ))}
              </AppStack>
            </AppFlexbox>
          </AppStack>
        </React.Fragment>
      );
    }
  );

WsCheckoutCartProductCardBundleItems.propTypes = {
  imageSize: PropTypes.number,
  packageItemsWithReferences: PropTypes.array
};

export default WsCheckoutCartProductCardBundleItems;
